import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    { question: "¿Qué voy a conseguir con CloserAcademy?", answer: "Obtendrás todas las técnicas para poder vender cualquier tipo de producto aplicando todas las técnicas que te enseñaremos." },
    { question: "¿Con qué tipos de empresas podré trabajar?", answer: "Dentro del sector hay una amplia variedad de empresas, desde aquellas especializadas en bienes raíces hasta firmas de asesoría en bufetes de abogados." },
    { question: "¿Cuál va a ser el proceso antes de trabajar?", answer: "El programa se estructura en 3 fases: en la primera fase, aprenderás toda la teoría a tu ritmo, con clases grabadas y en directo con David, además de contar con un guión probado y ejemplos de ventas reales. Recibirás apoyo continuo de David, su equipo, y la comunidad de alumnos. En la segunda fase, pondrás en práctica lo aprendido mediante simulaciones para prepararte plenamente. Finalmente, en la tercera fase, te enseñaremos técnicas para encontrar una empresa." },
    { question: "¿Cuántas horas le tendré que dedicar al día?", answer: "Para que el programa sea efectivo, pedimos un mínimo de 2 horas diarias, que podrás gestionar como prefieras. Al ser un trabajo desde casa, tú decides cuándo dedicarlas." }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-container">
      <h2>PREGUNTAS FRECUENTES</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <h3 className="faq-question">{faq.question}</h3>
            <div className="faq-answer" style={{ maxHeight: activeIndex === index ? "500px" : "0" }}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
